export default "__VITE_ASSET__B671QuLr__"